var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TheaterComedyRounded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 9H3C1.9 9 1 9.9 1 11V15.79C1 18.84 3.19 21.56 6.21 21.95C9.87 22.42 13 19.57 13 16V11C13 9.9 12.1 9 11 9ZM4 13.5C4 12.95 4.45 12.5 5 12.5C5.55 12.5 6 12.95 6 13.5C6 14.05 5.55 14.5 5 14.5C4.45 14.5 4 14.05 4 13.5ZM9.3 16.75C8.92 17.42 8.03 17.89 7 17.89C5.97 17.89 5.09 17.42 4.7 16.75C4.51 16.41 4.76 16 5.14 16H8.86C9.24 16 9.49 16.41 9.3 16.75ZM9 14.5C8.45 14.5 8 14.05 8 13.5C8 12.95 8.45 12.5 9 12.5C9.55 12.5 10 12.95 10 13.5C10 14.05 9.55 14.5 9 14.5Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 2H13C11.9 2 11 2.9 11 4V7.5H12.5C13.6 7.5 14.5 8.4 14.5 9.5V14.45C15.54 14.93 16.74 15.13 18 14.92C20.93 14.43 23 11.75 23 8.78V4C23 2.9 22.1 2 21 2ZM14 6.5C14 5.95 14.45 5.5 15 5.5C15.55 5.5 16 5.95 16 6.5C16 7.05 15.55 7.5 15 7.5C14.45 7.5 14 7.05 14 6.5ZM18.85 10.88H15.13C14.75 10.88 14.5 10.47 14.69 10.13C15.08 9.47 15.96 9 16.99 9C18.02 9 18.9 9.47 19.29 10.14C19.48 10.47 19.23 10.88 18.85 10.88ZM19 7.5C18.45 7.5 18 7.05 18 6.5C18 5.95 18.45 5.5 19 5.5C19.55 5.5 20 5.95 20 6.5C20 7.05 19.55 7.5 19 7.5Z",
    fill: "#121212"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesIcon);
export default __webpack_public_path__ + "static/media/roles-icon.548f36c408d7e90aba04b193ae5cf1e8.svg";
export { ForwardRef as ReactComponent };